<template>
  <div v-if="$companyConfiguration.evaluation.isEnabled()">
    <page-heading
      heading="Профили оценки"
    >
      <span slot="help"></span>
      <div slot="right">
        <div class="el-row--flex">
          <el-button
            type="primary"
            size="small"
            icon="fas fa-plus"
            @click="openEditDialog"
          >
            Добавить профиль
          </el-button>
        </div>
      </div>
    </page-heading>

    <el-card>
      <profiles-component
        ref="profilesComponent"
        :on-edit-profile="openEditDialog"
      ></profiles-component>
    </el-card>

    <profile-edit-dialog
      ref="editDialog"
      @profile-saved="loadProfiles"
    >
    </profile-edit-dialog>
  </div>
</template>

<script>
import ProfileEditDialog from "@/modules/evaluation/components/profile/ProfileEditDialog.vue";
import ProfilesComponent from "@/modules/evaluation/components/profile/ProfilesComponent.vue";
import PageHeading from "@/components/PageHeading";

export default {
  name: 'eval-profiles',
  components: {
    ProfilesComponent,
    ProfileEditDialog,
    PageHeading,
  },
  methods: {
    openEditDialog(profile = {}) {
      this.$refs.editDialog.open(profile);
    },
    loadProfiles(){
      if (this.$refs.profilesComponent) {
        this.$refs.profilesComponent.loadProfiles();
      }
    },
  }
}
</script>

<style scoped lang="scss">
  @import "./src/assets/css/project-variables";
</style>